import { Button, Dialog, DialogContent, DialogActions } from "@mui/material"
import { useState } from "react"
import { Form, ImageField, ImageInput, useNotify, useTranslate } from "react-admin"
import { useMutation } from "react-query";
import { AddLogoCommand, FileType } from "../GeneratedClients/FreeBillApi";
import { apiService } from "../apiService";
import blobToBase64 from "../files/blobToBase64";

const AddLogoDialog = () => {

  const translate = useTranslate()
  const [open, setOpen] = useState<boolean>(false)
  const notify = useNotify()

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const { mutate, isLoading } = useMutation((command: AddLogoCommand) => 
    apiService.UsersApi.addLogo({addLogoCommand: command, id: command.userId!}),
    {
      onSuccess: () => {
        notify('Logo hochgeladen')
        handleClose()
      },
      onError: (error: any) => {
        notify(error, {type: error})
      }
    }   
  )

  const handleSubmit = async (event: any)  => {
    if(!event.logo) {
      notify("Bitte wählen Sie ein Logo aus", {type: "error"})
      return
    }
    const userId = event.id
    const blob = event.logo.rawFile
    const fileContentAsBase64WithHeader = await blobToBase64(blob)
    const substrings = fileContentAsBase64WithHeader?.toString().split(',')
    const mimeType = substrings ? substrings[0] : null
    const fileContentAsBase64 = substrings ? substrings[1] : null
    const command: AddLogoCommand = {
      userId: userId,
      uploadedFileWithContent: {
        userId: userId,
        fileContentAsBase64: fileContentAsBase64,
        mimeType: mimeType,
        fileType: FileType.Picture
      } 
    }    
    mutate(command)
  }

  return (
    <>
      <Button onClick={handleClickOpen}>{translate("resources.logo.addLogo")}</Button>
      <Dialog 
        open={open} 
        onClose={handleClose}
      >
        <Form onSubmit={handleSubmit}>
          <DialogContent>
            <ImageInput 
              source="logo"
              accept={['image/jpeg', 'image/png']}
              maxSize={2000000}
              helperText="Dateitypen: JPG, PNG. Maximalgröße: 2MB."
            >
              <ImageField source="src" title="title"/>
            </ImageInput>
          </DialogContent>
          <DialogActions>
            <Button type='submit' disabled={isLoading}>{translate("ra.action.save")}</Button>
            <Button onClick={handleClose}>{translate("ra.action.cancel")}</Button>
          </DialogActions>
        </Form>
      </Dialog>
    </>
  )
}

export default AddLogoDialog